// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"FlowEditorPage__ellipsis__gY7FJ","flex-child-ellipsis":"FlowEditorPage__flex-child-ellipsis__1nYTs","multiplayer-cursor":"FlowEditorPage__multiplayer-cursor__160g2"};